<template>
    <div class="page-content">
        <div>
            <SketchBreadcrumb pageName="Cumpără licența" :tutorial="true" :tutorialLicenses="true" @startTutorial="tutorialStarted = $event"></SketchBreadcrumb>
            <div class="padding-box">
                <div class="pages-navigation white-box-smaller">
                    <div class="flex align-center space-between">
                        <router-link to="/aplicatii/m3-sketch" class="page-item pocSketchBtn">Scrie proiect</router-link>
                        <router-link :to="$route.fullPath.includes('m3-sketch') ? '/aplicatii/m3-sketch/licente/comanda-licenta' : '/licente/comanda-licenta'" class="page-item" :class="$route.path.includes('comanda-licenta') ? 'page-item-active' : ''">Comandă licență nouă</router-link>
                        <router-link :to="$route.fullPath.includes('m3-sketch') ? '/aplicatii/m3-sketch/licente/licentele-mele' : '/licente/licentele-mele'" class="page-item" :class="$route.path.includes('licentele-mele') ? 'page-item-active' : ''">Licențele mele</router-link>
                        <router-link :to="$route.fullPath.includes('m3-sketch') ? '/aplicatii/m3-sketch/licente/contracte-facturi' : '/licente/contracte-facturi'" class="page-item" :class="$route.path.includes('contracte-facturi') ? 'page-item-active' : ''">Contracte și facturi</router-link>
<!--                        <a href="/documents/MODEL_CONTRACT.pdf" download class="page-item"><p>Model contract (NDA)</p></a>-->
                    </div>
                    <p class="licenses-number"><span class="green-text">{{ licenseData.licensesAvailable + licenseData.licensesUsed }}</span> <span v-if="licenseData.licensesAvailable + licenseData.licensesUsed > 1 || licenseData.licensesAvailable + licenseData.licensesUsed === 0">licențe achiziționate</span> <span v-else>licență achiziționată</span></p>
                </div>
                <div class="mt-4">
                    <router-view
                        :licenseData="licenseData"
                        :licensesNotPaid="licensesNotPaid"
                        :tutorialStarted="tutorialStarted"
                        :statistics="statistics"
                        @tourClose="tutorialStarted = false"
                        @getLicenseData="getLicenseData(); getInvoices()"
                    >
                    </router-view>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { BFormCheckbox, BIconDownload, BFormInput} from 'bootstrap-vue'
    import SketchBreadcrumb from '@/pages/Aplicatii/M3/M3Sketch/components/SketchBreadcrumb'
    import axios from '@/helpers/axios'
    import api from '@/helpers/api'
    import _ from "lodash";
    export default {
        components: {
            SketchBreadcrumb,
            BFormCheckbox,
            BIconDownload,
            BFormInput,
        },
        data() {
            return {
                activePage: 0,
                licenseData: {
                    m2manager: null,
                    utm_source: null,
                    licensesUsed: null,
                    licensesAvailable: null,
                },
                licensesNotPaid: 0,
                tutorialStarted: false
            }
        },
        computed: {
            statistics() {
                return this.$store.getters['m3Sketch/indicators']
            },
            allData() {
                return this.$store.getters['m3Sketch/allData']
            }
        },
        watch:{
            allData: {
                handler: function() {
                },
                deep: false
            }
        },
        mounted() {
            this.getLicenseData()
            this.getInvoices()
        },
        methods: {
            getLicenseData() {
                axios.get(api.API_ENDPOINTS.m3Licenses)
                    .then( response => {
                        this.licenseData.m2manager = response.data.has_m2_manager
                        this.licenseData.utm_source = response.data.utm_source
                        this.licenseData.licensesUsed = response.data.m3_licenses_used
                        this.licenseData.licensesAvailable = response.data.m3_licenses_available
                        this.$store.dispatch('pageLoading/setLoading', false)
                    })
            },
            getInvoices() {
                axios.get(api.API_ENDPOINTS.m3Payment)
                    .then(response => {
                        let waitingPayments = _.filter(response.data.payments, v => v.status === 'In asteptare');
                        this.licensesNotPaid = 0
                        waitingPayments.forEach(payment => {
                            this.licensesNotPaid += payment.licenses
                        })
                        this.$store.dispatch('pageLoading/setLoading', false)
                    })
                    .finally(() => {this.loading = false})
            },
            changeActivePage(pageNumber){
                this.activePage = pageNumber
                this.$router.push({name: 'CumparaLicenta', params: { id: pageNumber }}).catch(()=>{});
            }
        }
    }
</script>

<style>
.left-image .chart::after{
    background: #1c1c1c  !important;
}
</style>
<style scoped>
.table td {
    border-top:none;
}
.flex{
    display: flex;
}
.space-between{
    justify-content: space-between;
}
.sketch-breadcrumb + .padding-box {
    height: calc(100% - 50px);
    padding-bottom: 100px;
}
.white-box{
    background: #fff;
    padding: 20px;
    height: 100%;
}
.white-box-smaller{
    background: #fff;
    padding: 10px;
    height: fit-content;
    max-height: 50px;
}
.pages-navigation{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
    justify-content: space-between;
}
.pages-navigation a:hover{
    text-decoration: none;
}
.page-item{
    font-size: 13px;
    color: #53596e;
    padding: 5px 30px;
    cursor: pointer;
    transition: 0.2s;
}
.page-item-active{
    background: linear-gradient(to bottom, #8c6984, #816e8b);
    color: #fff;
    border-radius: 2px;
}
.page-item:not(:last-child){
    border-right: 1px dotted #e3e4e7;
}

.mainFrameContent{
  width: 100%;
  overflow: auto;
}
.licenses-number{
    font-size: 15px;
    font-weight: 800;
    color: #53596e;
}
.red-text{
    color: #ea8196 !important;
}
.green-text{
    color: #49cda8 !important;
}
.pocSketchBtn{
	color: #fff;
	border-radius: 2px;
	background-color: #49cda8;
}
@media (max-width: 1240px){
    .white-box{
        padding: 0;
    }
    .page-item {
        padding: 5px 10px;
    }

}
</style>
